module.exports = __webpack_public_path__ + "img/peace-japanese1.911baaa1.png";